import angular from 'angular';
import constants from 'app/constants';
import {
  bcpSharedModelService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  ssAutocomplete
} from 'app/components/global';
import controller from './edit-process-succession-dialog.controller';
import template from './edit-process-succession-dialog.html';

// Validation
import processSuccessionMessagesTpl from './messages/processSuccession.messages.html';


class dialogService {
  getOptions($event, {
    assessmentId,
    departmentId,
    process,
    successorOptions
  }) {
    return {
      controller,
      controllerAs: 'editProcessSuccessionDialogVM',
      locals: {
        assessmentId,
        departmentId,
        process,
        successorOptions,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editProcessSuccessionDialog', [
  alerts,
  bcpSharedModelService,
  constants,
  loaderService,
  ssDialogService,
  ssAutocomplete,
])
  .service('editProcessSuccessionDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put(
      'processSuccession.messages.html', processSuccessionMessagesTpl
    );
  })
  .name;
